/*
const axios = require('axios').default;
export default {
    data() {
        return {
        collection: [],
        };
    },
    created(){
      axios
      /*
      .get({
        curl: 'http://localhost/prevent-tms-api/public/index.php/songs',
        requestTimeout: 10000,
        Accept: 'application/json',
      })
      */
/*
      .get('http://localhost/prevent-tms-api/public/index.php/all_video')
      .then(response => (this.collection = response.data.url)/*, this.video.description = response.data[this.video.position -1].description)*/
/*)
      .catch(error => console.log(error), this.video.url = preview)

      if (this.collection  == 'undefined'){
        this.collection = preview;
      }
    }

}*/
import { hostUrl } from "../_helpers/global_var";
export class VideoCollection {
    video_id;
    uri;
    collec;
    constructor(protocole, niveau, id_salarie) {
        const axios = require('axios').default;
        let uri = "";
        if (protocole == null || niveau == null || id_salarie == null) {
            uri = hostUrl + '/all_video';
        } else {
            uri = hostUrl + '/protocole/' + protocole + '/' + niveau + '/' + id_salarie;
        }
        axios
            .get(uri)
            .then(response => localStorage.video = JSON.stringify(response.data))
            .catch(error => console.log(error));
    }

}
/*
export class VideoCollection {
  video_id;
  url;
  niveaux;
  constructor(array){
    if (array !== null){
      for (let attribut in array) {
        let valeur = array[attribut];
        if (attribut == 'id' ){
            this.video_id = valeur;
        }else if (attribut == 'url' ){
            this.url = valeur;
        }else if (attribut == 'niveaux' ){
          this.niveaux = valeur;
        }
      }
    }
  }*/


// WEBPACK FOOTER //
// ./src/controller/Video.js